import { Injectable, Injector, afterNextRender, inject, signal } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ThermalReceipt, ThermalReceiptType } from '../models/thermal-receipt.model';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class ReceiptService {
  private injector = inject(Injector);
  private http = inject(HttpClient);
  private generation = 0;
  activeReceipt = signal<ThermalReceipt | null>(null);
  error = signal('');
  paperWidth = signal<58 | 80>(58);

  printTransaction(type: ThermalReceiptType, id: number | string): void {
    const requestGeneration = ++this.generation;
    this.error.set('');
    this.http.get<any>(`${environment.baseUrl}/receipts/${type}/${id}`).subscribe({
      next: (response) => { if (requestGeneration !== this.generation) return; void this.print({ ...response.data, txnDate: response.data.txnDate ? new Date(response.data.txnDate) : null }); },
      error: () => { if (requestGeneration === this.generation) this.error.set('Receipt could not be retrieved. Try again while online.'); },
    });
  }

  async print(receipt: ThermalReceipt): Promise<void> {
    const generation = ++this.generation;
    document.body.style.setProperty('--receipt-paper-width', `${this.paperWidth()}mm`);
    this.activeReceipt.set(receipt);
    let readyFinished = false;
    let timeout: ReturnType<typeof setTimeout> | undefined;
    const rendered = new Promise<void>((resolve) => afterNextRender(() => resolve(), { injector: this.injector }));
    try {
      await Promise.race([
        rendered.then(async () => {
          await document.fonts?.ready;
          await new Promise<void>((resolve) => {
            const check = () => {
              if (readyFinished || generation !== this.generation) { resolve(); return; }
              const images = [...document.querySelectorAll<HTMLImageElement>('app-thermal-receipt img')];
              if (images.every((img) => img.complete)) {
                requestAnimationFrame(() => requestAnimationFrame(() => resolve()));
              } else requestAnimationFrame(check);
            };
            check();
          });
        }),
        new Promise<void>((resolve) => { timeout = setTimeout(resolve, 5000); }),
      ]);
      if (generation === this.generation) window.print();
    } finally {
      readyFinished = true;
      if (timeout) clearTimeout(timeout);
    }
  }
}
